import * as React from "react";

import { PresentationProduct, PresentationThemeProduct } from "../../model";

import { usePlpAnalytics } from "../plp-analytics-provider";
import { useProductListRestoreScroll_asHigherOrderController } from "./product-list-restore-scroll-provider";

interface ProductListController_ForProduct_ConsumerInterface {
  handleActionProduct: (
    product: PresentationProduct,
    productIndex: number,
    openedProductId?: string
  ) => void;
  handleActionThemedProduct: (product: PresentationThemeProduct) => void;
}

const defaultValue =
  {} as unknown as ProductListController_ForProduct_ConsumerInterface;

const ProductListController_ForProduct_Context =
  React.createContext(defaultValue);

export const ProductListController_ForProduct_Provider: React.FunctionComponent =
  (props) => {
    const { analytics } = usePlpAnalytics();

    const { handleActionProduct: handleActionProduct_forRestoreScroll } =
      useProductListRestoreScroll_asHigherOrderController();

    const handleActionProduct = React.useCallback(
      (
        product: PresentationProduct,
        productIndex: number,
        openedProductId?: string
      ) => {
        analytics.clickActionOnProduct({
          presentationProduct: product,
          productIndex,
          openedProductId,
        });

        handleActionProduct_forRestoreScroll(product, productIndex);

        // a tag / link default behavior runs after this, navigating to the url
      },
      [analytics, handleActionProduct_forRestoreScroll]
    );

    const handleActionThemedProduct = React.useCallback(
      (product: PresentationThemeProduct) => {
        analytics.clickActionOnProductFromCampaign({
          presentationThemeProduct: product,
        });
      },
      [analytics]
    );

    const value: ProductListController_ForProduct_ConsumerInterface =
      React.useMemo(
        () => ({
          handleActionProduct,
          handleActionThemedProduct,
        }),
        [handleActionProduct, handleActionThemedProduct]
      );
    return (
      <ProductListController_ForProduct_Context.Provider value={value}>
        {props.children || []}
      </ProductListController_ForProduct_Context.Provider>
    );
  };

export const useProductListController_forProduct = () => {
  const value = React.useContext(ProductListController_ForProduct_Context);
  if (value === defaultValue) {
    throw new Error(
      "useProductListController_ForProduct_ must be used within a ProductListController_ForProduct_Provider"
    );
  }
  return value;
};
